/** LaunchDarkly boolean for service desk inbox / ticket-popup behavior. */
export const SERVICE_DESK_INBOX_LD_KEYS = [
  "service-desk-inbox",
  "serviceDeskInbox",
] as const;

export function isServiceDeskInboxFlagEnabled(
  flags: Record<string, unknown>
): boolean {
  for (const key of SERVICE_DESK_INBOX_LD_KEYS) {
    const v = flags[key];
    if (v === true) return true;
    if (typeof v === "string") {
      const s = v.trim().toLowerCase();
      if (s === "true" || s === "on" || s === "yes" || s === "1") return true;
    }
  }
  return false;
}
